module.exports = __webpack_public_path__ + "img/user_video_icon_black.6997c7c9.svg";